import React from 'react';
export var getStringFromReactNode = function getStringFromReactNode(children) {
  var label = '';
  React.Children.map(children, function (child) {
    if (typeof child === 'string') {
      label += child;
      return;
    }
    if (React.isValidElement(child) && child.props.children) {
      label += getStringFromReactNode(child.props.children);
      return;
    }
  });
  return label;
};